module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/id_okinawa-15d48cc76819e2f14530ec55cafebf36.jpg";